export class Filter {
	public boundsString?: string;
	public sport?: string = "all";
	public skill: string[] = [];
	public date: Date | null = null;
}